import { Directive, TemplateRef, ViewContainerRef, inject, OnInit } from '@angular/core';
import { ConfigService } from '@assist/shared/data';

@Directive({
  selector: '[zoomEnabled], [*zoomEnabled]',
  standalone: true,
})
export class ZoomEnabledDirective implements OnInit {
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private configService = inject(ConfigService);

  ngOnInit() {
    if (this.configService.value.zoomEnabled) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
